import { render, staticRenderFns } from "./AddPeopleModal.vue?vue&type=template&id=74f854e2&scoped=true&"
import script from "./AddPeopleModal.vue?vue&type=script&lang=js&"
export * from "./AddPeopleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPeopleModal.vue?vue&type=style&index=0&id=74f854e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f854e2",
  null
  
)

export default component.exports